module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAyElEQVQ4jZ3MPU5CURAG0OPbGttwISJRoyFgQkMjhR2FdJR0xgUQG6noKKxIDAmFCTEEbEYjDy/vZ5p755uZc3Z+N3lGQ/16yXCBfU1gj2aGV4xrImNMs2iusK0IbOPODzLHsCIyjLtfBG6xKQlsYl8eecdDSWQQ+0cIdLAuANbo/g3yyAq9AqSHj1MI9LFMAMuYH9R/yCfaCaQd80IEHrHIZYvIjyqFfOE6l91EXhqBEd7iP8NTavEUskMr/pfRV0Zggvt4k/UNJMYujdMWs0AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sj-icon.png
// module id = BgiZ
// module chunks = 0